import FeesTable from "./FeesTable";
import "../Pages.scss";
import "./Fees.scss";
import "../../styles/variables.scss";

// ✅ Reusable remark section
function RemarkSection({ title = "Remark(s):", items = [] }) {
  if (!items.length) return null;
  return (
    <div className="table-remark Ft-16s-24l-i">
      <div>{title}</div>
      <ul>
        {items.map((item, index) => (
          <li className="remark-dots" key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

function Fees() {
  // ===============================
  // RM Deposit & Withdrawal Fees
  // ===============================

  const rmDepositHeader = [
    { key: "method", label: "Channel(s)" },
    { key: "minAmount", label: "Min. Deposit Amount" },
    { key: "fee", label: "Deposit Fee" },
  ];

  const rmDepositList = [
    {
      method: "Online Bank Transfer (FPX)",
      minAmount: "RM10",
      fee: "RM1.00 charged below RM100",
    },
  ];

  const rmDepositRemarks = [
    "The deposit will be credited to the account within T+2 business days once the payment is completed.",
    "Transfers from third-party bank accounts will be rejected and refunded to the originating account within 30 days, subject to a refund fee of RM50.",
  ];

  const rmWithdrawalHeader = [
    { key: "method", label: "Channel(s)" },
    { key: "minAmount", label: "Min. Withdrawal Amount" },
    { key: "fee", label: "Withdrawal Fee" },
  ];

  const rmWithdrawalList = [
    { method: "Bank Transfer", minAmount: "RM10", fee: "RM0.50" },
  ];

  const rmWithdrawalRemarks = [
    "Withdrawal requests to third-party bank accounts will not be accepted.",
    "Withdrawal requests will be processed during working hours, excluding public holidays. The cutoff time for each request is 12pm, and any remaining requests will be processed the next day.",
  ];

  // ===============================
  // Crypto Deposit & Withdrawal Fees
  // ===============================

  const cryptoDepositHeader = [
    { key: "asset", label: "Crypto Asset" },
    { key: "network", label: "Network" },
    { key: "fee", label: "Deposit Fee" },
  ];

  const cryptoDepositList = [
    { asset: "Bitcoin (BTC)", network: "Bitcoin", fee: "Free" },
    { asset: "Ethereum (ETH)", network: "Ethereum (ERC20)", fee: "Free" },
    { asset: "Ripple (XRP)", network: "XRP Ledger", fee: "Free" },
    { asset: "Solana (SOL)", network: "Solana", fee: "Free" },
  ];

  const cryptoWithdrawalHeader = [
    { key: "asset", label: "Crypto Asset" },
    { key: "network", label: "Network" },
    { key: "minWithdrawal", label: "Min. Withdrawal Amount" },
    { key: "fee", label: "Withdrawal Fee" },
  ];

  const cryptoWithdrawalList = [
    {
      asset: "Bitcoin (BTC)",
      network: "Bitcoin",
      minWithdrawal: "0.0005 BTC",
      fee: "Dynamic*",
    },
    {
      asset: "Ethereum (ETH)",
      network: "Ethereum (ERC20)",
      minWithdrawal: "0.01 ETH",
      fee: "Dynamic*",
    },
    {
      asset: "Ripple (XRP)",
      network: "XRP Ledger",
      minWithdrawal: "10 XRP",
      fee: "Dynamic*",
    },
    {
      asset: "Solana (SOL)",
      network: "Solana",
      minWithdrawal: "0.01 SOL",
      fee: "Dynamic*",
    },
  ];

  const cryptoRemarks = [
    "*Dynamic fees are set by the blockchain network and vary depending on network traffic.",
  ];

  // ===============================
  // Buy/Sell Crypto with RM
  // ===============================

  const buySellHeader = [
    { key: "action", label: "Action" },
    { key: "rate", label: "Fee" },
    { key: "appliedOn", label: "Fee Applied On" },
  ];

  const buySellList = [
    { action: "Buy", rate: "1%", appliedOn: "Crypto Received" },
    { action: "Sell", rate: "1%", appliedOn: "RM Received" },
  ];

  const buySellRemarks = [
    "Fee is always deducted from the final amount received (crypto for buying, RM for selling).",
  ];

  // ===============================
  // KYC Verification Levels and Limits
  // ===============================

  const kycHeader = [
    { key: "level", label: "KYC Level" },
    { key: "dailyDeposit", label: "Daily RM Deposit" },
    { key: "dailyWithdrawal", label: "Daily RM Withdrawal" },
    { key: "dailyCryptoLimit", label: "Daily Crypto Withdrawal" },
  ];

  const kycList = [
    {
      level: "0",
      dailyDeposit: "N/A",
      dailyWithdrawal: "N/A",
      dailyCryptoLimit: "N/A",
    },
    {
      level: "1",
      dailyDeposit: "RM200,000.00",
      dailyWithdrawal: "RM200,000.00",
      dailyCryptoLimit: "RM1,000,000.00",
    },
    {
      level: "2",
      dailyDeposit: "Unlimited",
      dailyWithdrawal: "Unlimited",
      dailyCryptoLimit: "Unlimited",
    },
  ];

  const kycRemarks = [
    "Users at KYC Level 0 will not have access to any financial transaction features and may only explore the TorumPay application in a view-only mode.",
    "All financial transaction functionalities will be unlocked upon successful completion and approval of KYC Level 1 verification.",
  ];

  // ===============================
  // Render
  // ===============================
  return (
    <div className="tp-page-main-container">
      <div className="tp-page-main-wrapper max-width">
        <div className="tp-page-title Fu-70s-70l">FEE STRUCTURE</div>

        {/* RM Deposit & Withdrawal */}
        <div className="tp-table-section">
          <div className="tp-category-title Ft-24s-24l fw500">
            RM Deposit & Withdrawal Fees
          </div>
          <div className="table-wrapper">
            <FeesTable
              title="RM Deposit"
              header={rmDepositHeader}
              list={rmDepositList}
            />
            <RemarkSection items={rmDepositRemarks} />
          </div>
          <div className="table-wrapper">
            <FeesTable
              title="RM Withdrawal"
              header={rmWithdrawalHeader}
              list={rmWithdrawalList}
            />
            <RemarkSection items={rmWithdrawalRemarks} />
          </div>
        </div>

        {/* Crypto Deposit & Withdrawal */}
        <div className="tp-table-section">
          <div className="tp-category-title Ft-24s-24l fw500">
            Crypto Deposit & Withdrawal Fees
          </div>
          <div className="table-wrapper">
            <FeesTable
              title="Crypto Deposit"
              header={cryptoDepositHeader}
              list={cryptoDepositList}
            />
            <FeesTable
              title="Crypto Withdrawal"
              header={cryptoWithdrawalHeader}
              list={cryptoWithdrawalList}
            />
            <RemarkSection items={cryptoRemarks} />
          </div>
        </div>

        {/* Buy/Sell Crypto with RM */}
        <div className="tp-table-section">
          <div className="tp-category-title Ft-24s-24l fw500">
            Buy/Sell Crypto with RM
          </div>
          <div className="table-wrapper">
            <FeesTable
              title="Buy/Sell Crypto with RM"
              header={buySellHeader}
              list={buySellList}
            />
            <RemarkSection items={buySellRemarks} />
          </div>
        </div>

        {/* KYC Verification */}
        <div className="tp-table-section">
          <div className="tp-category-title Ft-24s-24l fw500">
            KYC Verification Levels and Limits
          </div>
          <div className="table-wrapper">
            <FeesTable
              title="KYC Verification Levels and Limits"
              header={kycHeader}
              list={kycList}
            />
            <RemarkSection items={kycRemarks} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Fees;
